import NoImpactBanner from "@/components/NoImpactBanner/NoImpactBanner";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import { useCompanyAccess } from "@/hooks/useCompanySettings";
import styles from "@/pages/dashboard/Dashboard.module.scss";
import { Link, useNavigate } from "react-router-dom";
import MetricSelector from "../components/MetricSelector/MetricSelector";
import YearPicker from "../components/YearPicker/YearPicker";
import { useDashboardYear } from "../hooks/useDateRange";
import { useEmployeeImpactTotals } from "../hooks/useEmployeeImpact";
import useImpactMetric from "../hooks/useImpactMetric";
import EmployeeImpactPerScope from "./widgets/EmployeeImpactPerScope";
import EmployeeImpactPerType from "./widgets/EmployeeImpactPerType";
import EmployeeImpactTopContributors from "./widgets/EmployeeImpactTopContributors";
import EmployeeImpactTotal from "./widgets/EmployeeImpactTotal";
import PremiumExplore from "@/components/PremiumFeatureComponents/PremiumExplore";

export default function EmployeeDashboard() {
  const metric = useImpactMetric();
  const navigate = useNavigate();
  const access = useCompanyAccess();

  const { data: totalImpact } = useEmployeeImpactTotals({ metrics: [metric.key] });
  const { year } = useDashboardYear();
  const pageTitle = `Employee impact`;
  const pageDescription = "Get insights into employee commuting and business travel impact.";

  if (access && !access.includes("lca"))
    return (
      <PremiumExplore
        title={pageTitle}
        description={pageDescription}
      />
    );

  return (
    <div>
      <PageHeader
        title={pageTitle}
        description={pageDescription}
        right={
          <>
            <YearPicker />
          </>
        }
      />
      <MetricSelector
        value={metric.key}
        onChange={(key) => navigate("/dashboard/employee/" + key)}
      />
      {totalImpact?.employee_impact[metric.key] === 0 ? (
        <NoImpactBanner title={`No employee impact for ${year}`}>
          <span>
            Please upload <Link to="/employees/commute">employee commuting</Link> and{" "}
            <Link to="/employees/business_travel">business travel</Link> data for 2024 and match
            their <Link to="/employees/travel_modes">travel modes</Link> with the impact references.
          </span>
        </NoImpactBanner>
      ) : (
        <div className={styles.grid}>
          <div className={styles["two-columns"]}>
            <div>
              <EmployeeImpactTotal metric={metric} />
              {metric.key === "carbon_footprint" && <EmployeeImpactPerScope />}
            </div>
            <div>
              <EmployeeImpactTopContributors metric={metric} />
            </div>
          </div>
          <div className={styles["one-column"]}>
            <EmployeeImpactPerType metric={metric} />
          </div>
        </div>
      )}
    </div>
  );
}
